import React from 'react';
import { useTranslation } from 'react-i18next';
import { PrescriptionItem as PrescriptionItemType } from '../../types/prescription.types';

interface PrescriptionItemProps {
  item: PrescriptionItemType;
}

export const PrescriptionItem: React.FC<PrescriptionItemProps> = ({ item }) => {
  const { t } = useTranslation();
  
  return (
    <div style={{ borderBottom: '1px solid #e5e7eb', paddingBottom: '0.5rem', marginBottom: '0.5rem' }}>
      <p className="fw-semibold mb-1">{item.drugName}</p>
      <p className="text-muted small mb-1">
        {item.dose} - {item.duration} {t('common.days', 'يوم')}
      </p>
      {item.notes && <p className="text-muted small mb-0">{item.notes}</p>}
    </div>
  );
};

